import { combineEpics, ofType } from 'redux-observable';
import { map, debounceTime } from 'rxjs/operators';

import {
  TOGGLE_SORT,
  PAGINATION_CHANGE,
  SEARCH,
  ADVANCED_SEARCH,
  load,
} from './actions';

const updateEpic = action => action.pipe(
  ofType(TOGGLE_SORT, PAGINATION_CHANGE, ADVANCED_SEARCH),
  map(load),
);

const searchEpic = action => action.pipe(
  ofType(SEARCH),
  debounceTime(150),
  map(load),
);

export default combineEpics(
  updateEpic,
  searchEpic,
);
